import React from 'react';
import { css } from '@emotion/core';
import { useSelector } from 'react-redux';

import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import { AngularServicesContext } from 'react-app';
import { getCurrentUser } from 'redux/selectors/users';
import { FullCourse } from 'redux/schemas/models/courseFull';
import { hexToRgbaString } from 'styles/global_defaults/colors';
import { halfSpacing } from 'styles/global_defaults/scaffolding';
import { OfferingContext } from 'offerings/components/offering-card';
import {
  openSans,
  boldFontWeight,
  textMediumFontSize,
  textMediumLineHeight,
} from 'styles/global_defaults/fonts';

type Props = {
  className?: string,
  style?: React.CSSProperties,
};

const CompletedStatusOverlay = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    style,
    className,
  } = props;

  const currentUser = useSelector(getCurrentUser);
  const offering = React.useContext(OfferingContext);
  const { $state } = React.useContext(AngularServicesContext);

  const styles = css`
    color: #fff;
    padding: ${halfSpacing}px;

    & > div {
      width: 100%;
      height: 100%;
      text-align: center;
      border: 1px solid ${hexToRgbaString('#fff', 0.6)};
    }

    .icon {
      margin-bottom: ${halfSpacing}px;
    }

    .info {
      color: #fff;
      font-family: ${openSans}px;
      font-weight: ${boldFontWeight};
      font-size: ${textMediumFontSize}px;
      line-height: ${textMediumLineHeight}px;
    }
  `;

  const hasCertificate = (offering as unknown as FullCourse).soaCertificateEnabled;
  const linkToCertificate = $state.href(
    offering.isJourney ? 'journey-statement-modal' : 'statement-modal',
    {
      userId: currentUser.id,
      catalogId: offering.catalogId,
    },
  );

  return (
    <div
      ref={ref}
      css={styles}
      style={style}
      className={className}
    >
      <div className='d-flex flex-column justify-content-center align-items-center'>
        {hasCertificate ? (
          <a
            className='info'
            href={linkToCertificate}
            onClick={(e) => e.stopPropagation()}
          >
            <NvIcon
              icon='badge'
              size='medium'
            />
            {t.OFFERINGS.CARD.VIEW_CERTIFICATE()}
          </a>
        ) : (
          <div className='info'>
            {t.OFFERINGS.CARD.CONGRATULATIONS()}
          </div>
        )}
      </div>
    </div>
  );
});

export default CompletedStatusOverlay;
